export default __webpack_public_path__ + "img/fdovizIy.f349c69b.svg";